export default __webpack_public_path__ + "static/media/bio4.e2cf453e.jpg";